<template>
    <div >
        <label for="administrativeArea">{{ label }}</label>
        <select 
            id="administrativeArea"
            class="form-control"
            :value="modelValue"
            @input="$emit('change', $event.target.value)"
        >
            <option value="">Select {{ label }}</option>
            <optgroup v-if="options.length" :label="optGroupLabel">
                <option 
                    v-for="option in options" 
                    :key="option.code" 
                    :value="option.code"
                >
                    {{ option.name }}
                </option>
            </optgroup>
        </select>
    </div>
</template>

<script>
const US_STATES = [
    { name: 'Alabama', code: 'AL' },
    { name: 'Alaska', code: 'AK' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'Arizona', code: 'AZ' },
    { name: 'Arkansas', code: 'AR' },
    { name: 'California', code: 'CA' },
    { name: 'Colorado', code: 'CO' },
    { name: 'Connecticut', code: 'CT' },
    { name: 'Delaware', code: 'DE' },
    { name: 'District of Columbia', code: 'DC' },
    { name: 'Federated States of Micronesia', code: 'FM' },
    { name: 'Florida', code: 'FL' },
    { name: 'Georgia', code: 'GA' },
    { name: 'Guam', code: 'GU' },
    { name: 'Hawaii', code: 'HI' },
    { name: 'Idaho', code: 'ID' },
    { name: 'Illinois', code: 'IL' },
    { name: 'Indiana', code: 'IN' },
    { name: 'Iowa', code: 'IA' },
    { name: 'Kansas', code: 'KS' },
    { name: 'Kentucky', code: 'KY' },
    { name: 'Louisiana', code: 'LA' },
    { name: 'Maine', code: 'ME' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Maryland', code: 'MD' },
    { name: 'Massachusetts', code: 'MA' },
    { name: 'Michigan', code: 'MI' },
    { name: 'Minnesota', code: 'MN' },
    { name: 'Mississippi', code: 'MS' },
    { name: 'Missouri', code: 'MO' },
    { name: 'Montana', code: 'MT' },
    { name: 'Nebraska', code: 'NE' },
    { name: 'Nevada', code: 'NV' },
    { name: 'New Hampshire', code: 'NH' },
    { name: 'New Jersey', code: 'NJ' },
    { name: 'New Mexico', code: 'NM' },
    { name: 'New York', code: 'NY' },
    { name: 'North Carolina', code: 'NC' },
    { name: 'North Dakota', code: 'ND' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Ohio', code: 'OH' },
    { name: 'Oklahoma', code: 'OK' },
    { name: 'Oregon', code: 'OR' },
    { name: 'Palau', code: 'PW' },
    { name: 'Pennsylvania', code: 'PA' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Rhode Island', code: 'RI' },
    { name: 'South Carolina', code: 'SC' },
    { name: 'South Dakota', code: 'SD' },
    { name: 'Tennessee', code: 'TN' },
    { name: 'Texas', code: 'TX' },
    { name: 'Utah', code: 'UT' },
    { name: 'Vermont', code: 'VT' },
    { name: 'Virgin Islands', code: 'VI' },
    { name: 'Virginia', code: 'VA' },
    { name: 'Washington', code: 'WA' },
    { name: 'West Virginia', code: 'WV' },
    { name: 'Wisconsin', code: 'WI' },
    { name: 'Wyoming', code: 'WY' }
];

const CANADIAN_PROVINCES = [
    { name: 'Alberta', code: 'AB' },
    { name: 'British Columbia', code: 'BC' },
    { name: 'Manitoba', code: 'MB' },
    { name: 'New Brunswick', code: 'NB' },
    { name: 'Newfoundland and Labrador', code: 'NL' },
    { name: 'Northwest Territories', code: 'NT' },
    { name: 'Nova Scotia', code: 'NS' },
    { name: 'Nunavut', code: 'NU' },
    { name: 'Ontario', code: 'ON' },
    { name: 'Prince Edward Island', code: 'PE' },
    { name: 'Quebec', code: 'QC' },
    { name: 'Saskatchewan', code: 'SK' },
    { name: 'Yukon', code: 'YT' }
];

export default {
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        country: {
            type: String,
            required: true
        }
    },

    emits: ['update:modelValue'],

    computed: {
        options() {
            switch(this.country) {
                case 'US':
                    return US_STATES;
                case 'CA':
                    return CANADIAN_PROVINCES;
                default:
                    return [];
            }
        },

        label() {
            switch(this.country) {
                case 'US':
                    return 'State';
                case 'CA':
                    return 'Province';
                default:
                    return 'State/Province';
            }
        },

        optGroupLabel() {
            switch(this.country) {
                case 'US':
                    return 'US States';
                case 'CA':
                    return 'Canadian Provinces';
                default:
                    return '';
            }
        }
    }
}
</script>